module.exports = __webpack_public_path__ + "img/britek.4a92a57a.svg";